import React from 'react';
import '../css/services/Services.css';
import CTAButtons from './CTAButtons';
import SEO from './SEO';

const Services = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      // For contact, scroll to contact-info section for better mobile experience
      if (sectionId === 'contact') {
        const contactInfo = document.getElementById('contact-info');
        if (contactInfo) {
          // Add offset for mobile to ensure contact info is visible
          const isMobile = window.innerWidth <= 768;
          const offset = isMobile ? 80 : 20;
          
          const elementPosition = contactInfo.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: elementPosition - offset,
            behavior: 'smooth'
          });
          return;
        }
      }
      
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const services = [
    {
      id: 1,
      icon: 'fas fa-coins',
      title: 'Wealth Management',
      description: 'Comprehensive wealth management solutions tailored to your financial goals. We provide strategic guidance for building, preserving, and growing your wealth through diversified investment approaches.',
      features: [
        'Personalized investment strategies',
        'Risk assessment & management',
        'Long-term wealth planning',
        'Regular portfolio reviews'
      ]
    },
    {
      id: 2,
      icon: 'fas fa-chart-pie',
      title: 'Portfolio Management',
      description: 'Professional portfolio management services designed to optimize your investments across various asset classes, ensuring balanced risk-return profiles suited to your investment horizon.',
      features: [
        'Asset allocation strategies',
        'Market research & analysis',
        'Performance monitoring',
        'Rebalancing & optimization'
      ]
    },
    {
      id: 3,
      icon: 'fas fa-handshake',
      title: 'Business Debt Provision',
      description: 'Strategic business debt solutions to support your commercial ventures and growth initiatives. We provide financing options that align with your business objectives and cash flow requirements.',
      features: [
        'Flexible financing options',
        'Competitive interest rates',
        'Quick approval process',
        'Customized repayment terms'
      ]
    }
  ];

  return (
    <>
      <SEO 
        title="Samapaw Services - Comprehensive Financial Solutions"
        description="Discover Samapaw comprehensive financial services: Samapaw Wealth Management with personalized strategies, Samapaw Portfolio Management with asset optimization, and Samapaw Business Debt Provision with flexible financing options in Gurugram."
        keywords="Samapaw services, Samapaw wealth management services, Samapaw portfolio management Gurugram, Samapaw business debt provision, Samapaw financial consultation services, Samapaw asset allocation strategies, Samapaw investment advisory India, Samapaw financial planning Haryana, Sama paw services"
        section="services"
      />
      <section id="services" className="services">
      <div className="container">
        <div className="services-header text-center">
          <h2>Our Services</h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">
            Comprehensive financial solutions designed to create and preserve wealth
          </p>
        </div>

        <div className="services-grid">
          {services.map(service => (
            <div key={service.id} className="service-card">
              <div className="service-icon">
                <i className={service.icon}></i>
              </div>
              
              <div className="service-content">
                <h3>{service.title}</h3>
                <p className="service-description">{service.description}</p>
                
                <ul className="service-features">
                  {service.features.map((feature, index) => (
                    <li key={index}>
                      <i className="fas fa-check"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                
                <button 
                  className="btn btn-outline service-btn"
                  onClick={() => scrollToSection('contact')}
                >
                  Contact for more info
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="services-cta">
          <div className="cta-content">
            <h3>Ready to Start Your Wealth Journey?</h3>
            <p>Contact us today to discuss how our services can help you achieve your financial goals.</p>
            <CTAButtons />
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default Services;